import { StringUtils } from "abweb/utils/StringUtils";
export class Translator {
  constructor(namespaceManager) {
    this.namespaceManager = namespaceManager;
    if (namespaceManager == null) {
      throw new Error("Locale NamespaceManager must be non-null.");
    }
  }

  /**
   *
   * @param nsKey of form '<namespace>:<key>' such as 'abweb:ERROR_FOO'
   * @param msgArgs
   * @return {string} null if string not found, otherwise string with arg substitution
   */
  getMessage(resourceBundleKey, msgKey, ...msgArgs) {
    const res = this.namespaceManager.getResource(resourceBundleKey, msgKey);
    return msgArgs.length === 0 || !res // if res is empty string or null, return it
    ? res : StringUtils.sprintf(res, ...msgArgs);
  }
}
//# sourceMappingURL=Translator.js.map
